import {
  USER_ATTRIBUTE_GIVEN_NAME,
  USER_ATTRIBUTES_STORAGE_KEY_PREFIX,
  USER_ATTRIBUTES_STORAGE_KEY_SUFFIX,
} from '~/utils/constants';
import { getStorageDataByPartialKeys } from '~/utils/storage';

import { UserAttributesData } from './model';

export const getUserName = () => {
  const storageData = getStorageDataByPartialKeys({
    startsWith: USER_ATTRIBUTES_STORAGE_KEY_PREFIX,
    endsWith: USER_ATTRIBUTES_STORAGE_KEY_SUFFIX,
  }) as UserAttributesData;

  return storageData?.UserAttributes.find(
    ({ Name }) => Name === USER_ATTRIBUTE_GIVEN_NAME
  )?.Value;
};
